export const defaultSearchParam = 'q';
